import React from 'react';
import TableBodyMui, { TableBodyProps } from '@material-ui/core/TableBody';

export const TableBody: React.FC<TableBodyProps> = ({ children, ...rest }) => {
	return <TableBodyMui {...rest}>{children}</TableBodyMui>;
};
